export const SMS_ALLOWED_TOKENS = ['org', 'phone', 'subjectName', 'retries', 'interval'] as const;

const TOKEN_RE = /\{([^{}]*)\}/g;

export function unknownSmsTokens(value: string): string[] {
  const unknown: string[] = [];
  for (const match of value.matchAll(TOKEN_RE)) {
    const name = match[1];
    if (!(SMS_ALLOWED_TOKENS as readonly string[]).includes(name)) {
      unknown.push(match[0]);
    }
  }
  return unknown;
}

/** Rejects `{…}` placeholders that are not in the allowed token set. */
export function smsTokensValidator(control: { value: unknown }): { smsTokens: { unknown: string[] } } | null {
  const unknown = unknownSmsTokens(String(control.value ?? ''));
  return unknown.length ? { smsTokens: { unknown } } : null;
}
